import { memo } from 'react';
import { cn } from '@divlab/divanui';

import styles from './FormItem.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface FormItemProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  label?: React.ReactNode | string;
  bottom?: React.ReactNode | string;
  hidden?: boolean;
  view?: 'primary' | 'secondary' | 'wide';
  simple?: boolean;
  inModal?: boolean;
  cnContent?: string;
  children: React.ReactNode | React.ReactNode[];
}

const FormItem: FC<FormItemProps> = (props) => {
  const {
    className,
    label,
    bottom,
    hidden,
    view = 'primary',
    simple,
    inModal,
    cnContent,
    children,
    ...restProps
  } = props;

  return (
    <div
      {...restProps}
      className={cn(
        styles.formItem,
        {
          [styles.hidden]: hidden,
          [styles.viewPrimary]: view === 'primary',
          [styles.viewSecondary]: view === 'secondary',
          [styles.wide]: view === 'wide',
          [styles.simple]: simple,
          [styles.inModal]: inModal,
        },
        className,
      )}
    >
      {label && <div className={styles.label}>{label}</div>}
      <div className={cn(styles.content, cnContent)}>{children}</div>
      {bottom && <div className={styles.bottom}>{bottom}</div>}
    </div>
  );
};

export default memo(FormItem);
